// src/pages/events/Webinar2025.js
import React, { useMemo } from 'react';
import { useCollection } from '../../hooks/useCollection';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import './Webinar2025.css'; // reuse existing styles

export default function Webinar2025() {
  const { documents, error } = useCollection('events', null, ['date', 'desc']);

  // Normalize past_event: support boolean true or string "yes"
  const isPast = (doc) => {
    const v = doc?.past_event;
    if (typeof v === 'string') return v.toLowerCase() === 'yes';
    return !!v;
  };

  // Only 2025 Computational Modeling series (type: "Webinar") that are past/completed
  const past2025Docs = useMemo(() => {
    if (!documents) return [];
    const filtered = documents.filter((d) => d?.type === 'Webinar' && isPast(d));
    // Sort newest first
    filtered.sort((a, b) => b.date.toDate() - a.date.toDate());
    return filtered;
  }, [documents]);

  return (
    <div className="eventCalendarWrapper">
      <Navbar />

      <div className="eventCalendarHeader">
        <h1>Neuromodec Webinar Series on</h1>
        <h1>Computational Modeling</h1>
        <p className="series-subtext">
          Completed webinars from the 2025 Computational Modeling Series. Recordings will be available soon.
        </p>
      </div>

      {/* Single-column content area */}
      <div className="eventCalendarLayout single">
        {error && <p className="error">{error}</p>}

        {past2025Docs.length === 0 ? (
          <p className="muted">No completed webinars are available yet.</p>
        ) : (
          <ul className="eventList">
            {past2025Docs.map((doc) => (
              <li key={doc.id} className="eventListItem">
                <Link to={`/events/${doc.id}`} className="eventCardLink">
                  <div className="eventCardHorizontal">
                    <div className="eventCardImageWrap">
                      <img src={doc.img_url} alt={doc.name} />
                    </div>
                    <div className="eventCardContent">
                      <h3 className="eventTitle">{doc.name}</h3>
                      <p className="eventMeta">
                        {doc.day === ''
                          ? 'Date: TBD'
                          : `${doc.day}, ${doc.month} ${doc.day_digit}, ${doc.year} | ${doc.start_time} - ${doc.end_time} (ET)`}
                      </p>
                      {/* We’re not showing “Watch” yet since recordings are coming soon */}
                      {/* <span className="completed-badge">Watch Webinar</span> */}
                    </div>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
        )}

        {/* CTA to main events page */}
        {/* <div style={{ marginTop: 24, textAlign: 'center' }}>
          <p className="muted" style={{ marginBottom: 12 }}>
            The 2025 Webinar Series is ongoing. Check out upcoming sessions!
          </p>
          <Link to="/events" className="btnPrimary" style={{ display: 'inline-block' }}>
            Browse Upcoming Webinars
          </Link>
        </div> */}
      </div>
    </div>
  );
}
